export default "__VITE_ASSET__BP5zXcqZ__"